import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  bottomRowWrapper: {
    paddingTop: Theme.px(51),
  },
  weatherAlertsContentWrapper: {
    flexDirection: 'row',
    paddingTop: Theme.px(30),
  },
  weatherAlertsHeaderWrapper: {
    flexDirection: 'row',
    paddingLeft: Theme.px(90),
  },
  twcAccessibleContentContainer: {
    flexDirection: 'row',
  },
});
